<template>
  <!-- <div class="page-loader">
    <div class="spinner"></div>
  </div> -->
  <div class="section">
    <div class="order-list-container">
      <h2 class="page-title">주문목록</h2>
      <!-- 주문 내역 없음 -->
      <div v-if="orderList.length <= 0" class="no-data">주문 내역이 없습니다.</div>
      <!-- 주문 내역 리스트 -->
      <div v-else class="order-list">
        <div v-for="order in orderList" :key="order.id" class="order-card">
          <div class="card-header">
            <span class="order-date">{{ order.create_datetime }}</span>
            <span class="order-id">주문번호 {{ order.order_id }}</span>
          </div>

          <div class="card-body">
            <h3 class="product-name">
              <span :class="['status-badge', getStatusClass(order.market_delivery_status_id)]">
                {{ order.status_label }}
              </span>
              {{ order?.orderList[0]?.product_name }}
              <span v-if="order?.orderList?.length > 1">
                외 {{ order?.orderList.length - 1 }} 건
              </span>
            </h3>
          </div>

          <div class="card-footer">
            <RouterLink
              :to="{
                path: `/myOrder`,
                state: {
                  list: JSON.stringify(order),
                },
              }"
              class="btn-detail"
            >
              상세보기
            </RouterLink>
            <RouterLink
              v-show="!isEmpty(idntCode)"
              :to="{
                path: `/inquiry`,
                state: {
                  goodsCode: order.orderList[0].goods_code,
                  request: JSON.stringify(order),
                },
              }"
              class="btn-detail type2"
            >
              1:1문의
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import api from '@/utils/api.js';
import router from '@/router';
import { _getStorageWithExpiry, _safeAtob } from '../utils/common.js';
import { isEmpty } from 'lodash';

const route = useRoute();

const data = JSON.parse(history?.state?.data || '{}');
const idntCode = _safeAtob(_getStorageWithExpiry('id'));

onMounted(() => {
  getData();
});

const orderList = ref([]);

const getData = async () => {
  let param = {
    mode: 'marketOrderList',
    type: 'G',
  };

  if (isEmpty(idntCode)) {
    param.orderNumber = data.orderNumber;
  } else {
    param.idnt_code = idntCode;
  }

  const response = await api.post('/order.php', param);

  if (response.data) {
    orderList.value = response.data.data;
  }
};

const getStatusClass = code => {
  switch (code) {
    case '1':
      return 'badge-red'; // 준비중
    case '12':
      return 'badge-green'; // 배송중
    case '2':
      return 'badge-grey'; // 완료
    case '5':
      return 'badge-red'; // 결제전****
    case '6':
      return 'badge-green'; // 결제완료****
    case '8':
      return 'badge-grey'; // 취소****
    default:
      return '';
  }
};
</script>
